<script lang="ts">
  import Stack from "../../Stack.svelte";
  import TextNew from "../../TextNew.svelte";

  export let title: string;
  export let subtitle: string | undefined = undefined;
  export let borderBottom: boolean = true;
</script>

<div class="container" class:border-bottom={borderBottom}>
  <Stack vertical alignItems="stretch">
    <TextNew size="xl">{title}</TextNew>
    {#if subtitle}
      <TextNew size="s">{subtitle}</TextNew>
    {/if}
  </Stack>
  <div class="action">
    <slot />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
  }

  .border-bottom {
    border-bottom: solid 1px var(--rk-divider-0);
  }

  .action {
    align-self: flex-start;
  }
</style>
